module.exports = __webpack_public_path__ + "static/media/-_Job opportunities.e74042bc.png";